import * as OnboardingModalApp from "../onboarding-modal/onboardingModalApp";
import * as PopUpModal from "../pop-up-modal/popUpApp";
import * as DocumentAccessModal from "../document-access-modal/documentAccessApp";
// import * as BadgesModal from "../badgefication-modal/badgesModalApp";

export const initialize = () => {
  const popup = document.getElementById("js-react-popup-app");
  const documentAccess = document.getElementById(
    "js-react-document-access-app"
  );
  const onboarding = document.getElementById("js-react-onboarding-app");
  // const badgefication = document.getElementById("js-react-badges-app");

  if (documentAccess) DocumentAccessModal.initialize();
  else if (popup) PopUpModal.initialize();
  else if (onboarding) OnboardingModalApp.initialize();
  //else if(onboarding) //BadgesModal.initialize(); // TODO: Reactivate this when reactivating badgification
};
